<template>
    <div>
        <div class="logout-button" @mouseover="hover = true" @mouseleave="hover = false">
            <a :href="googleLogin">
                <img v-show="!hover" src="/images/btn_google_signin_light_normal_web.png" />
                <img v-show="hover" src="/images/btn_google_signin_light_focus_web.png" />
            </a>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { Bus, Stops } from '../../common/bus';
import auth from '../../common/auth';

export default {
    data() {
        return {
            hover: false,
        };
    },
    created() {
        Bus.$emit(Stops.TITLE_CHANGED, 'Logg inn med...');
        Bus.$emit(Stops.NAVBAR, 'None');
        if (this.isAuthenticated) this.$router.push({ name: 'Catches' });
    },
    computed: {
        ...mapState('session', ['isAuthenticated']),
        googleLogin() {
            return auth.loginLinkGoogle();
        },
    },
};
</script>

<style lang="scss" scoped>
.logout-button {
    padding: 1rem;
    margin: auto;
    flex: 1;
    width: $maxContentWidth/3;
    text-align: center;
}
</style>
